import React from 'react';


export class error extends React.Component {


	
	render(){
		return (
			<div id="contactos">
		
				<section class="container-fluid contact-container">
						<article class="row justify-content-md-left">
							<div class="col-8 col-form-box">
								<div class="bg-box-form">
									<h3>Error</h3>
									
								</div>
								
							</div>
						</article>
						
					</section>
			</div>
		);
	}
} 


// WEBPACK FOOTER //
// ./src/components/error.js